import { BaseDocumentosService } from "../base/baseDocumentos";

export class DocumentosService extends BaseDocumentosService {
  async guardarDocumento(values: any) {
    try {
      const { data } = await this.axiosClient.post(`/`, values);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarDocumento with stack: ${error}`);
    }
  }
  async consultarDocumento(id: number) {
    try {
      const { data } = await this.axiosClient.get(`/consultarDocumento/${id}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in consultarDocumento with stack: ${error}`);
    }
  }
  async guardarArchivo(archivo: any) {
    try {
      const { data } = await this.axiosClient.post(`/guardarArchivo`, archivo, {
        headers: { "content-type": "multipart/form-data" },
      });
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarArchivo with stack: ${error}`);
    }
  }
  
  async consultarArchivo(filename: string) {
    if (!filename || filename === "null" || filename === "undefined" || (typeof filename === "string" && filename.trim() === "")) {
      return null;
    }
    try {      
      const data = await this.axiosClient.get(`/consultarArchivos/${filename}`, {
        responseType: "blob",
      });
      return data;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  /**
   * Lectura de un PDF para la verificación automática: si pide contraseña y su capa de texto.
   * Devuelve null si el análisis falla, para que la verificación siga con los demás documentos.
   */
  async analizarDocumento(filename: string) {
    try {
      const { data } = await this.axiosClient.get(`/analizarDocumento/${filename}`);
      return data;
    } catch (error) {
      console.error(`No se pudo analizar el documento ${filename}:`, error);
      return null;
    }
  }

  async consultarArchivo2(filename: string) {
    try {
      const data = await this.axiosClient.get(`/consultarArchivos2/${filename}`, {
        responseType: "blob",
      });
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in consultarArchivo with stack: ${error}`);
    }
  }

  async eliminarArchivo(filename: string) {
    try {
      const { data } = await this.axiosClient.delete(`/eliminarArchivo/${filename}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in consultarArchivo with stack: ${error}`);
    }
  }

  async consultarArchivosEstaticos(filename: string) {
    try {
      let data = await this.axiosClient.get(`/consultarArchivosEstaticos/${filename}/terminos`, {
        responseType: "blob",
      });
      return data;
    } catch (error) {
      return console.error(`An unhandled exception in postConvocatoria with stack: ${error}`);
    }
  }
}

export default new DocumentosService();